// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__YkIkg","productName":"Table_productName__2sUrG"};